const filters = {
  // 时间戳转化为日期格式 datesString:13位 fmt yyyy-MM-dd hh:mm:ss
  FormatDate: function (datesString, fmt) {
    datesString = Number(datesString) * 1000;

    let getDate = new Date(datesString);
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds()
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt;
  },
  // 时间差
  DateDiff(startTime, endTime, type) {
    let timeDiff = endTime - startTime;
    let diffStr = 0;
    if (type == 'year') {
      diffStr = timeDiff / 86400 / 365;
      return diffStr.toFixed(2) + '年';
    } else if (type == 'month') {
      diffStr = timeDiff / 86400 / 30;
      return diffStr.toFixed(2) + '月';
    } else if (type == 'day') {
      diffStr = timeDiff / 86400;
      return diffStr.toFixed(2) + '天';
    } else if (type == 'hour') {
      diffStr = timeDiff / 3600;
      return diffStr.toFixed(2) + '小时';
    } else if (type == 'minute') {
      diffStr = timeDiff / 60;
      return diffStr.toFixed(2) + '分钟';
    } else if (type == 'second') {
      diffStr = timeDiff % 60;
      return diffStr.toFixed(2) + '秒';
    }
  },

}

export default filters



// WEBPACK FOOTER //
// ./src/commonJs/Filters.js